import React from "react";
import { useNavigate } from "react-router-dom";
import "./LibraryPdf.css";

export default function Library() {
  const navigate = useNavigate();
  

  /* ================= BOOK DATA ================= */

  const books = [
  {
    title: "Misbahussalat - Namaz Ka Tarika",
    author: "MUFTI MOHSIN MISBAHI SAHAB",
    language: "Gujarati",
    topics: "Salah / Prayer",
    image:
      "https://drive.google.com/thumbnail?id=1SGRdf2uQs3t0k3uhBMBBO6hrkn1KH0yW&sz=w1000",
    file:
      "https://drive.google.com/file/d/1BvPOUU6WRJf3bywx6dViv7z3lDb4gcRM/view?usp=drivesdk",
  },

  {
    title: "Misbahul Wazaaif",
    author: "SAYYED IMRAN ALI KADRI",
    language: "Gujarati",
    topics: "Wazaaif / Islamic Knowledge",
    image:
      "https://drive.google.com/thumbnail?id=1i3cdKckTy6zZIvUXwGhVW6xUUUJ65jEf&sz=w1000",
    file:
      "https://drive.google.com/file/d/14KSooG_HaIROAZlpjLKABxSbfbHqAvjh/view?usp=drivesdk",
  },

  {
    title: "Napaki ke Ahkam No.1",
    author: "MUFTI MOHSIN MISBAHI SAHAB",
    language: "Gujarati",
    topics: "Taharat / Islamic Law",
    image:
      "https://drive.google.com/thumbnail?id=1EzJnT8Ov1fJ1wANqmdyeHBtEeEUqf8Wq&sz=w1000",
    file:
      "https://drive.google.com/file/d/1jqfPnFefxixCTFkrHQf62AOMaR4Xrrba/view?usp=drivesdk",
  },

  {
    title: "Napak Kapdo Ko Paak Kaise Kare No. 2",
    author: "MUFTI MOHSIN MISBAHI SAHAB",
    language: "Gujarati",
    topics: "Taharat / Islamic Law",
    image:
      "https://drive.google.com/thumbnail?id=1-m6Gs2nvnLoG572-9PXF2uYLGxHY0vrM&sz=w1000",
    file:
      "https://drive.google.com/file/d/1e7q4wsTUjgVRBOtw6UrYTqGp32HBNDQJ/view?usp=drivesdk",
  },

  {
    title: "Azan Ke Bare Mein Masaail",
    author: "MUFTI MOHSIN MISBAHI SAHAB",
    language: "Gujarati",
    topics: "Azan / Islamic Knowledge",
    image:
      "https://drive.google.com/thumbnail?id=1U4XQ83cM4ggR03nVXckgooQ1sS3cjg3g&sz=w1000",
    file:
      "https://drive.google.com/file/d/1eeE6Dn3h7jjKgpE2CSpNEKoD6jU7DIKg/view?usp=drivesdk",
  },

  {
    title: "Ya-Seen Sharif & Fatiha Ka Tarika",
    author: "MUFTI MOHSIN MISBAHI SAHAB",
    language: "Gujarati",
    topics: "Ya-Seen / Fatiha / Islamic Knowledge",
    image:
      "https://drive.google.com/thumbnail?id=1esrSq88Y4qQJoz4YjSFZDTv-VHzqTiov&sz=w1000",
    file:
      "https://drive.google.com/file/d/11yyYIoh_c4IMJUKt5gEubtccLFy_lpgs/view?usp=drivesdk",
  },

  {
    title: "Darse Hadis 3",
    author: "MUFTI MOHSIN MISBAHI SAHAB",
    language: "Gujarati",
    topics: "Hadith / Islamic Knowledge",
    image:
      "https://drive.google.com/thumbnail?id=1ptDCDXkGREx2Zg6YztOYi9jMTdxYnhMx&sz=w1000",
    file:
      "https://drive.google.com/file/d/1HqJT9BB1v265yvBVYLqNkRg0KqTuoWj3/view?usp=drivesdk",
  },

  {
    title: "Darse Hadis",
    author: "MUFTI MOHSIN MISBAHI SAHAB",
    language: "Gujarati",
    topics: "Hadith / Islamic Knowledge",
    image:
      "https://drive.google.com/thumbnail?id=1101y8Mr7VNX5EEssQ5vS35xLQ6RqlkXS&sz=w1000",
    file:
      "https://drive.google.com/file/d/1RmrlQRw2JmCgnClTcgHh9G9mMBNSkXQR/view?usp=drivesdk",
  },

  {
    title: "Misbahi Darul Ifta",
    author: "MUFTI MOHSIN MISBAHI SAHAB",
    language: "Gujarati",
    topics: "Darul Ifta / Islamic Knowledge",
    image:
      "https://drive.google.com/thumbnail?id=19i1f9XTzoF7aOVXyqeeV0B6DXuehSgMw&sz=w1000",
    file:
      "https://drive.google.com/file/d/14ZNJhDF87hfwWBbxbZJUR-pN9BrAZ3gA/view?usp=drivesdk",
  },
];

  return (
    <div className="library-page">

      <div className="container">

        {/* ================= PAGE HEADER ================= */}

        <div className="library-header">

          <div className="library-subtitle">
            بِسْمِ اللهِ الرَّحْمٰنِ الرَّحِيْمِ
          </div>

          <h2 className="library-title">
            📚 Book Collection
          </h2>

          <h3 className="library-arabic-title">
            مَجْمُوعَةُ الكُتُبِ
          </h3>

          <div className="library-divider">
            <i className="bi bi-star-fill"></i>
          </div>

          <p className="library-description">
            Explore a collection of Islamic books and educational
            resources dedicated to spreading knowledge, faith,
            and spiritual guidance.
          </p>


        </div>




        {/* ================= LIBRARY BOOKS ================= */}

        <div className="row g-4 library-books">

          {books.map((book, index) => (

            <div
              className="col-12 col-md-6 col-lg-4"
              key={index}
            >

              {/* ================= BOOK CARD ================= */}

              <div className="library-card">

                {/* ================= BOOK COVER ================= */}

                <div className="library-cover-wrapper">

                  <img
                    src={book.image}
                    className="library-cover"
                    alt={book.title}
                  />

                </div>

                {/* <div className="library-cover-wrapper">
                  <div className="css-book-cover">
                    <div className="css-book-cover-icon">
                      <i className="bi bi-book-half"></i>
                    </div>

                    <div className="css-book-cover-title">
                      {book.title}
                    </div>

                    <div className="css-book-cover-author">
                      {book.author}
                    </div>

                    <div className="css-book-cover-bottom">
                      MISBAHI WELFARE MISSION
                    </div>
                  </div>
                </div> */}

                {/* ================= BOOK INFORMATION ================= */}

                <div className="library-card-body">

                  <h6 className="library-book-title">

                    <i className="bi bi-book-half me-2"></i>

                    {book.title}

                  </h6>


                  {/* ================= BOOK DETAILS ================= */}

                  <ul className="library-details">

                    <li>

                      <i className="bi bi-person-fill"></i>

                      <span>
                        <strong>Author:</strong>{" "}
                        {book.author}
                      </span>

                    </li>


                    <li>

                      <i className="bi bi-translate"></i>

                      <span>
                        <strong>Language:</strong>{" "}
                        {book.language}
                      </span>

                    </li>


                    <li>

                      <i className="bi bi-bookmark-fill"></i>

                      <span>
                        <strong>Topic:</strong>{" "}
                        {book.topics}
                      </span>

                    </li>

                  </ul>


                  {/* ================= ACTION BUTTONS ================= */}

                  <div className="library-actions">

                    {/* READ BUTTON */}

                    <a
                      href={book.file}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="library-read-btn"
                    >

                      <i className="bi bi-book"></i>

                      Read

                    </a>


                    {/* DOWNLOAD BUTTON */}

                    <a
                      href={book.file}
                      download
                      className="library-download-btn"
                    >

                      <i className="bi bi-download"></i>

                      Download

                    </a>

                  </div>

                </div>

              </div>

            </div>

          ))}

        </div>

      </div>

    </div>
  );
}